import "./App.css";
import RouterPage from "./route/RouterPage";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { PageProvider } from "./context/PageContext";
import Header from "./parts/Header/Header";
import Sidebar from "./parts/Sidebar/Sidebar";
import Footer from "./parts/Footer/Footer";
import Login from "./pages/Login/Login";
import DemoCall from "./pages/DemoCall/DemoCall";
import { useState } from "react";
import { Toaster } from "react-hot-toast";

function App() {
  // console.log = function () {};
 
  const [sidebarToggle, setSidebartoggle] = useState(window.innerWidth <= 991);
  const toggle = () => {
    setSidebartoggle(!sidebarToggle);
  };

  if (process.env.NODE_ENV === "production") {
    console.log = function () {};
  }

  return (
    <div className="App">
      <PageProvider>
        <Router>
          <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
          <Switch>
            <Route path="/" exact component={Login} />
            <Route path="/demo-call" exact component={DemoCall} />
            <div className="warrper">
              <div className="main_page">
                <div className="container-lg main-inner">
              
                  <Sidebar sidebarToggle={sidebarToggle} toggle={toggle} />
                  <Header sidebarToggle={sidebarToggle} toggle={toggle} />
                  <div 
                    className="content-wrapper" 
                    style={{
                      marginLeft: sidebarToggle ? "70px" : "260px",
                      paddingTop: "64px"
                    }}
                  >
                    <RouterPage />
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </Switch>
        </Router>
      </PageProvider>
    </div>
  );
}

export default App;